import React from 'react'
import styles from "./tnpsc-admissions.module.css";
import Link from 'next/link';

const About_TNPSC = () => {
 
  const thirdlist3 =[
    {list:"Our test series is a real simulation of the TNPSC Group I Prelims exam."},
    {list:"Our test series covers the syllabus holistically. "},
    {list:"Our test series is based on the dynamism of TNPSC"},
    {list:"All the tests will be conducted for 200 questions only"},
    {list:"We do post test discussion analysis on the perspective of difficulty level, conceptual level, Current Event level, etc.,"},
    {list:"Recorded post test discussion analysis will be provided for further reference."},
    {list:"Provides a platform for State Level Analysis of performance and improves your competency."},
    {list:"Flexible for working candidates to take the test as per their availability."}
  ]
   const thirdlist4 =[
    {list:"Free Interview classes."},
    {list:"Individual attention."},
    {list:"Mock Interview by serving bureaucrats and others."},
    {list:"Mock Interview will be recorded and analysis will be shared for further enhancement."}
  ]
  return (
    <>


    <div className='container'>
      <div className='row'>
        <div className='col-lg-6 col-12 p-3' style={{backgroundColor:"#E4E8ED"}}>
        <p className={`${styles.contenttitles}`}>Prelims Test Series</p>
        <ul className={`${styles.ulclass} ps-1 pt-3 mb-0`}>
          {thirdlist3.map((item,index)=>(
              <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                      <div className="d-inline">
                          <p className={`${styles.ullispan} d-inline`}>
                          {item.list}
                          </p>
                      </div>
                </li>
          ))}
      </ul>

      <p className={`${styles.contenttitles} pt-3 mb-0`}>Group I Test Series - 2022</p>
      <p className={`${styles.sectionsubtitle}`}>Regular Weekend Online</p>
       <Link href="/tnpsc-group-i-prelims-test" ><button className={`${styles.normalbutton1} mt-2 mt-md-0`} type="submit">Click here to join</button></Link>
 
        </div>
        <div className='col-lg-6 col-12 p-3'style={{backgroundColor:"#D9DFE6"}}>
        <p className={`${styles.contenttitles}`}>Interview Guidance</p>
        <ul className={`${styles.ulclass} ps-1 pt-3 mb-0`}>
            {thirdlist4.map((item,index)=>(
                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                            {item.list}
                            </p>
                        </div>
                  </li>
            ))}
        </ul>

        </div>
      </div>
    </div>


    </>
  )
}

export default About_TNPSC;